import React from 'react';
import { Nav } from 'react-bootstrap';

const NavItemComponent = ({ eventKey, children, navRef }) => {
  return (
    <Nav.Item>
      <Nav.Link ref={navRef} eventKey={eventKey} className='shadow rounded-3 py-3 py-md-5 px-3'>
        {children}
      </Nav.Link>
    </Nav.Item>
  );
};

export default NavItemComponent;
